import { createSelector } from '@ngrx/store';

import * as fromReducer from '@packages/packages-result/store/reducers/hotel-results.reducer';
import { PackageResultModuleState } from '@packages/packages-result/store/state/packages-result-module.state';
import { packagesResultRootSelector } from '@packages/packages-result/store/selectors/packages-result-root.selector';
import { HotelResultsState } from '@packages/packages-result/store/reducers/hotel-results.reducer';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { mapHotelMarkers } from '@hotels/hotel-results/mappers/hotel-results.mapper';

export const getHotelResultsState = createSelector(
  packagesResultRootSelector, (state: PackageResultModuleState) => state?.hotelResults);

export const getHotelMarkersState = createSelector(
  packagesResultRootSelector, (state: PackageResultModuleState) => state?.hotelMarkers);

export const selectAllHotelResults = createSelector(getHotelResultsState, fromReducer.selectAll);
export const hotelMarkers = createSelector(getHotelMarkersState, (state: HotelResultsState) => Object.values(state?.entities));
export const hotelResultsWithMarkers = createSelector(hotelMarkers, (state: HotelSearched[]) => mapHotelMarkers(state));
